//libraries
import React, { memo, useContext } from "react";

//components
import WithStyles from "shared/components/WithStyles";
import MenuItem from "shared/components/Header/DesktopHeader/components/Auth/components/MenuItem";

//context
import { SubNavContext } from "shared/components/SubNav";

//constants
import { TEXTS } from "shared/components/Header/DesktopHeader/components/Auth/constants";

//styles
import { loggedCss } from "./styles";

//def
interface ILoggedInProps {
    customerData: any;
}

function LoggedIn({ customerData }: ILoggedInProps) {
    const { doHide } = useContext(SubNavContext);

    const goToMyOrder = () => {
        doHide();
        window.location.href = "/sales/order/history";
    };

    const goToWishlist = () => {
        doHide();
        window.location.href = "/wishlist";
    };

    const logout = () => {
        doHide();
        window.location.href = "/customer/account/logout";
    };

    const firstChar = customerData.firstname.substring(0, 1);

    return (
        <>
            <WithStyles cssProps={loggedCss}>
                <div className="lg-char">{firstChar}</div>
                <div className="lg-name">{TEXTS.HI_USER(customerData.firstname)}</div>
            </WithStyles>
            <MenuItem onClick={goToMyOrder} iconClassName="icon-orders" title={TEXTS.MY_ORDER} />
            <MenuItem onClick={goToWishlist} iconClassName="icon-heart" title={TEXTS.MY_WISHLIST} />
            <MenuItem onClick={logout} iconClassName="icon-log-out" title={TEXTS.LOGOUT} />
        </>
    );
}

export default memo(LoggedIn);
